module.exports = __webpack_public_path__ + "img/indus-pic-10.e749c5f4.png";